import React from "react";

export default function ApartmentTitle({ apartment }) {
  return (
    <div className="mb-3">
      <h2 className="text-lg font-bold">{apartment.housingCompanyName}</h2>
      <p>{apartment.location.address}</p>
    </div>
  );
}
